// given a <select class="js-aut-redirect">, when
// changing its seleted option, redirect to the url
// in the option value.
export default function () {
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (
      target.tagName == 'SELECT' &&
      target.classList.contains('js-auto-redirect')
    ) {
      var url = target.value;
      if (url) {
        location.href = url;
      }
    }
  });
}
